module.exports = __webpack_public_path__ + "img1.f9feba9.png";